





















































































import {Component, Watch } from 'vue-property-decorator';
import {CardForm} from '@/components/bwaff';
import Form, {Send} from '@/components/form-base';
import Api from '@/services';
import { validationMixin, Validation } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { ValidationProperties, ValidationGroups } from 'vue/types/vue';
import { mixins } from 'vue-class-component';
import { get} from 'lodash';

const validations = {
  token: {
    required,
    valid: (value: string, vm: TwoFactor) => vm.isTokenValid
  },
}

@Component({
  components: {
    CardForm,
  },
  validations: validations
})
export default class TwoFactor extends mixins<Form>(Form, validationMixin) {
  error: boolean = false;
  error_message: string = '';
  trust: boolean = true;
  token: string = '';
  show_password: boolean = false;
  edit: boolean = true;
  form: object = {};

  isTokenValid: boolean = true;

  // @ts-ignore
  $v:  ValidationProperties<typeof validations> & ValidationGroups & Validation;

  get sendDisabled() {
    return !this.$v.token.required;
  }

  get twoFactorQrCode() {
    return get(this.$store.state,'member.twoFactorQrCode');
  }

  get rightSideTitle() {
    return this.twoFactorQrCode
      ? this.t('Two-Factor Authentication')
      : this.t('Second authentication') ;
  }

  get codeFromGoogleTitle() {
    return this.twoFactorQrCode
      ? this.t('Code From Google Authenticator')
      : this.t('Code From App or Backup Code') ;
  }

  getClientErrors(field: string) {
    let errors: string[] = [];
    switch(field) {
      case 'token':
        if(this.$v.token.$dirty) {
          if(!this.$v.token.required) {
            errors.push(this.t('Field "Code" is required'));
          }

          if(!this.$v.token.valid) {
            errors.push(
              this.t('Invalid code')
            );
          }
        }
        break;
    }

    return errors;
  }

  getError(input: string):  any[] {
    let errors = this.pGetError(input);

    errors = errors
      ? errors.map((error: any) => this.t(error))
      : [];

    return errors.concat(this.getClientErrors(input));
  }

  get clientErrorsState() {
    return [
      !this.$v.token.required && this.$v.token.$dirty,
      !this.$v.token.valid && this.$v.token.$dirty,
    ];
  }

  @Watch('clientErrorsState')
  onClientErrorsStateUpdated(value: boolean[], oldValue: boolean[]) {
    this.formUpdateState();
  }

  formUpdateState() {
    const form = this.$refs.form as CardForm;
    form.updateState();
  }

  created() {
    const { t } = (this as any);
    const $on = this.$on.bind(this);

    $on('error:400', () => {
      this.error = true;
      this.error_message = t('Wrong email or password');
    });

    $on('error:401', () => {
      this.error = true;
      this.error_message = t('Wrong email or password');
    });

    $on('error:403', () => {
      this.error = true;
      this.error_message = t('Wrong email or password');
    });
  }

  handleTokenInput() {
    this.isTokenValid = true;
  }

  finishAuth() {
    Api.loadProfileData().then(() => {
      this.$store.commit('login');
      this.$store.commit('secondFactorAuth', true);

      this.$router.push(Api.getDashboardLink(this.$store.state.user));
    });
  }

  @Send()
  async submit() {
    try {
      const payload = await Api.checkToken({
        token: this.token,
        trust: this.trust
      });

      if(payload.result) {
        if(payload.backupCodeUsed) {
          this.bus.emit('open-dialog', { name: 'TwoFactorBackupCodeDialog', data: { onClose: () => this.finishAuth() } });
        } else {
          this.finishAuth();
        }
      } else {
        this.isTokenValid = false;
        return Promise.reject(null);
      }
    } catch(error) {
      //return Promise.reject(error);
    }
  }
}
